<template>
<div :class="{interval: visible}">
<slot v-show="visible"></slot>
</div>
</template>

<script>
import { FadeInVisible } from '@/FadeInVisible';
export default {
  mixins: [ FadeInVisible ]
}
</script>

<style lang="scss" scoped>
.interval {
  opacity: 0;
  animation: interval 1s ease-in-out;
  animation-fill-mode: both;
  animation-delay: .1s;
}
@keyframes interval {
  0% {
    opacity: 0;
    letter-spacing: .5rem;

  }
  100% {
    opacity: 1;
    letter-spacing: .2rem;
  }
}
</style>